import { render } from "./ClearCacheModal.vue?vue&type=template&id=6861188f&ts=true"
import script from "./ClearCacheModal.vue?vue&type=script&lang=ts"
export * from "./ClearCacheModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__